import loadable from '@loadable/component';

export const AsyncNotFound = loadable(() => import('./NotFound'));
